import { render } from "./bulkSupplierFZFReportList.vue?vue&type=template&id=21b97b1c&scoped=true"
import script from "./bulkSupplierFZFReportList.vue?vue&type=script&lang=js"
export * from "./bulkSupplierFZFReportList.vue?vue&type=script&lang=js"

import "./bulkSupplierFZFReportList.vue?vue&type=style&index=0&id=21b97b1c&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b97b1c"]])

export default __exports__